
import CreateEditCustomer from "../../Components/Customers/CreateEditCustomer";


export default function CreateCustomer(){
    return(
        <CreateEditCustomer/>
    )
}